var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('notifications',{staticStyle:{"font-family":"Roboto"},attrs:{"group":"default"}}),(!_vm.loadingInitialState)?_c('router-view',{key:_vm.$route.fullPath}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }